//商品详情页
export function loadProduct(productId) {
  return {
    type: 'LOAD_PRODUCT',
    productId,
  };
}

export function loadProductCompletion(productId, data, error) {
  return {
    type: 'LOAD_PRODUCT_COMPLETION',
    productId,
    data,
    error,
  };
}

export function loadXgProductLimitInfo(productId) {
  return {
    type: 'LOAD_XG_PRODUCT_LIMIT_INFO',
    productId,
  };
}

export function loadXgProductLimitInfoCompletion(productId, error, data) {
  return {
    type: 'LOAD_XG_PRODUCT_LIMIT_INFO_COMPLETION',
    productId,
    error,
    data,
  };
}

//购物袋
export function loadProductsByIds(productIds) {
  return {
    type: 'LOAD_PRODUCTS_BY_IDS',
    productIds,
  };
}

export function loadProductsByIdsCompletion(productIds, data, error) {
  return {
    type: 'LOAD_PRODUCTS_BY_IDS_COMPLETION',
    productIds,
    list: (data && data.listData) || [],
    error,
  };
}

//首页商品列表
export function loadAllLimitProductList(actId) {
  return {
    type: 'LOAD_ALL_LIMIT_PRODUCT_LIST',
    actId,
  };
}

export function loadAllLimitProductListCompletion(actId, error, data) {
  return {
    type: 'LOAD_ALL_LIMIT_PRODUCT_LIST_COMPLETION',
    actId,
    error,
    list: (data && data.listData) || [],
  };
}

export function loadAllKillProductList() {
  return {
    type: 'LOAD_ALL_KILL_PRODUCT_LIST',
  };
}

export function loadAllKillProductListCompletion(error, data) {
  return {
    type: 'LOAD_ALL_KILL_PRODUCT_LIST_COMPLETION',
    error,
    list: (data && data.listData) || [],
  };
}

export function loadAllGroupProductList(actId) {
  return {
    type: 'LOAD_ALL_GROUP_PRODUCT_LIST',
    actId,
  };
}

export function loadAllGroupProductListCompletion(error, data) {
  return {
    type: 'LOAD_ALL_GROUP_PRODUCT_LIST_COMPLETION',
    error,
    data,
  };
}

export function loadAllOverseaProductList(range) {
  return {
    type: 'LOAD_ALL_OVERSEA_PRODUCT_LIST',
    range,
  };
}

export function loadAllOverseaProductListCompletion(error, data) {
  return {
    type: 'LOAD_ALL_OVERSEA_PRODUCT_LIST_COMPLETION',
    error,
    list: (data && data.listData) || [],
  };
}

// 商品评论
export function loadProductCommentList(productId, query) {
  return {
    type: 'LOAD_PRODUCT_COMMENT_LIST',
    productId,
    query,
    willReload: !!query,
  };
}

export function loadProductCommentListCompletion(error, list, count) {
  return {
    type: 'LOAD_PRODUCT_COMMENT_LIST_COMPLETION',
    error,
    list,
    count,
  };
}

export function loadHomeProductSearchList(query) {
  return {
    type: 'LOAD_HOME_PRODUCT_SEARCH_LIST',
    query,
    willReload: !!query,
  };
}

export function loadHomeProductSearchListCompletion(error, list) {
  return {
    type: 'LOAD_HOME_PRODUCT_SEARCH_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadProductPicker(query) {
  return {
    type: 'LOAD_PRODUCT_PICKER',
    query,
    willReload: !!query,
  };
}

export function loadProductPickerCompletion(error, list) {
  return {
    type: 'LOAD_PRODUCT_PICKER_COMPLETION',
    error,
    list,
  };
}

export function inputForProductPicker(input) {
  return {
    type: 'INPUT_FOR_PRODUCT_PICKER',
    input,
  };
}

export function deinitProductPicker() {
  return {
    type: 'DEINIT_PRODUCT_PICKER',
  };
}

export function loadWaitGroupList() {
  return {
    type: 'LOAD_WAIT_GROUP_LIST',
  };
}

export function loadWaitGroupListCompletion(error, data) {
  return {
    type: 'LOAD_WAIT_GROUP_LIST_COMPLETION',
    error,
    data,
  };
}

// 随机商品列表
export function loadRandomProductList(query) {
  return {
    type: 'LOAD_RANDOM_PRODUCT_LIST',
    query,
    willReload: !!query,
  };
}

export function loadRandomProductListCompletion(error, list) {
  return {
    type: 'LOAD_RANDOM_PRODUCT_LIST_COMPLETION',
    error,
    list,
  };
}
export function loadRandomGroupProductList(query) {
  return {
    type: 'LOAD_RANDOM_GROUP_PRODUCT_LIST',
    query,
    willReload: !!query,
  };
}

export function loadRandomGroupProductListCompletion(error, list) {
  return {
    type: 'LOAD_RANDOM_GROUP_PRODUCT_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadPackageProductList() {
  return {
    type: 'LOAD_PACKAGE_PRODUCT_LIST',
  };
}

export function loadPackageProductListCompletion(error, list) {
  return {
    type: 'LOAD_PACKAGE_PRODUCT_LIST_COMPLETION',
    error,
    list,
  };
}
